import script from "./WarningLetterList.vue?vue&type=script&setup=true&lang=js"
export * from "./WarningLetterList.vue?vue&type=script&setup=true&lang=js"

import "./WarningLetterList.vue?vue&type=style&index=0&id=59ec6b47&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59ec6b47"]])

export default __exports__